import React, { Component } from 'react';
import './LoginView.css';
import { GoogleLogin } from 'react-google-login-component';

export default class LoginView extends Component {

constructor(props, context) {
    super(props, context);
    this.state ={
      showLogin: true,
      googleKey: process.env.REACT_APP_GOOGLEKEY,
    }

  }

  componentDidMount(){
     this.checkGoogleLogin()
  }



  /*---------------------------------------
      CHECK LOGIN GOOGLE
  -----------------------------------------*/
  checkGoogleLogin(){

    console.log("Checking login...");

    if(localStorage.userData){

      this.setState({
          showLogin: false
      })
      window.location.href = '/'

    }else{
      this.setState({
          showLogin: true
      })
    }

  }



  /*---------------------------------------
      GOOGLE
  -----------------------------------------*/
  responseGoogle (googleUser) {

    const id_token = googleUser.getAuthResponse().id_token;
    const googleId = googleUser.getId()
    const googleName = googleUser.getBasicProfile().getName()
    const googleEmail = googleUser.getBasicProfile().getEmail()

    const userData = {
      id: googleId,
      email: googleEmail,
      name: googleName,
      token: id_token
    }

      localStorage.setItem("userData", JSON.stringify(userData));

      let apiUrl;

      if(window.location.hostname === 'localhost')
      {
        apiUrl = 'http://127.0.0.1:3030'
      }else{
       apiUrl = 'http://trainer.activepipe.com:3030'
      }
      const url = apiUrl  + '/login';
      fetch(url, {
        method: 'POST',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        },
        body: JSON.stringify(
        {
          user_id: googleId,
          token: id_token,
          email: googleEmail,
          name: googleName
        })
      })
      .then((response) => response.json())
      .then((responseJson) =>
      {
        console.log("Logged in succesfully");
        window.location.href = '/'

      })
      .catch((error) => {
          console.log("Error");
          console.error(error);
          alert("Something went wrong logging in!")
      });

  }

   /*---------------------------------------

  /*---------------------------------------
      RENDER
  -----------------------------------------*/
  render() {

    return (
      <div className="App">

        {this.state.showLogin ?
          <div>
            <div className={"login"}>
            <img src={"../assets/images/logos/activepipe.svg"} alt="ActivePipe"/>
             <GoogleLogin socialId={this.state.googleKey}
                         className="googleButton"
                         scope="profile email"
                         fetchBasicProfile={true}
                         responseHandler={this.responseGoogle}
                         buttonText="Sign In With Google"
                         hostedDomain="activepipe.com"
                         />
            </div>
            <div className={"image"}></div>
          </div>
       : null }
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/views/LoginView/LoginView.js